<template>
  <PageVC class="booking booking-preorder-menu">
    <div class="a-container">
      <h1 class="a-page-title">Forudbestilling</h1>
      <HUILoadingView v-if="!booking || !order || !entered || !menu" />
      <template v-else>
        <Menu
          class="a-container__offset"
          :is-lunch="booking.is_lunch"
          @add-burger="handleMenuAddBurger"
          @add-product="handleMenuAddProduct"
        ></Menu>
        <RouterButton
          class="booking-preorder-menu__continue-button"
          theme="green"
          :to="routes.BOOKING_PREORDER_CART"
        >Vis forudbestilt mad</RouterButton>
      </template>
    </div>
  </PageVC>
</template>

<script>
import { mapState } from 'vuex'
import { HUILoadingView } from '@/halifax-ui'
import BookingPreorderBase from '@/views/BookingPreorderBase'
import PageVC from '@/containers/PageVC'
import RouterButton from '@/containers/RouterButton'
import Menu from '@/containers/Menu'

export default {
  extends: BookingPreorderBase,
  components: {
    PageVC,
    HUILoadingView,
    RouterButton,
    Menu
  },
  computed: {
    ...mapState('user', {
      userClientToken: 'client_token'
    }),
    hasMarkedReady() {
      return this.orderLines.some(orderLine => {
        return orderLine.customer_token === this.userClientToken && orderLine.is_ready
      })
    }
  },
  methods: {
    async markNotReady() {
      this.$store.dispatch('dialog/ALERT', {
        props: {
          heading: 'Din bestilling er ikke længere afsluttet',
          body: 'Husk at afslutte din bestilling i kurven.'
        }
      })
      this.$store.dispatch('order/MARK_NOT_READY', this.orderToken)
    },
    async handleMenuAddBurger(config) {
      const payload = {
        type: 'burger',
        burger_id: config.id,
        bun_id: config.bun,
        patty_id: config.patty,
        frying_id: config.frying,
        ingredients: config.ingredients,
        quantity: config.quantity
      }

      if (this.hasMarkedReady) {
        this.markNotReady()
      }

      try {
        await this.$store.dispatch('order/ADD_ITEM', { payload, orderToken: this.orderToken })
      } catch (error) {
        this.$store.dispatch('toast/ERROR', error.message)
      }
    },
    async handleMenuAddProduct({ id, quantity }) {
      const payload = {
        type: 'product',
        product_id: id,
        quantity
      }

      if (this.hasMarkedReady) {
        this.markNotReady()
      }

      try {
        await this.$store.dispatch('order/ADD_ITEM', { payload, orderToken: this.orderToken })
      } catch (error) {
        this.$store.dispatch('toast/ERROR', error.message)
        this.fetchBooking()
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/scss/variables';
@import '~@/halifax-ui/src/scss/framework';

.booking-preorder-menu {
  $module: '.booking-preorder-menu';

  &__continue-button {
    margin-top: 40px;
  }
}
</style>
